import client from './client.js';

// POST /api/cfdi/emitir
// receptor: { rfc, razon_social, codigo_postal, regimen_fiscal?, uso_cfdi? }
// items:    [{ name, quantity, unit_price, clave_prod_serv?, clave_unidad? }]
// forma_pago: 'cash' | 'card' | 'transfer' | 'credit'
export const emitirFactura = ({ receptor, items, forma_pago, pos_payment_id }) =>
  client.post('/cfdi/emitir', { receptor, items, forma_pago, pos_payment_id }).then((r) => r.data.data);
